import State from '../interfaces/states/State';

import * as moment from 'moment';

import { createSelector } from 'reselect';

const getActivityYears = createSelector(
  (state: State) => state.activity.activityData,
  (activityData): number[] => {
    if (activityData.dates) {
      return activityData.dates.map((month) => {
        return Number(moment(month).format('YYYY'));
      });
    } else {
      return null;
    }
  }
);

export default getActivityYears;
